import * as s from './OnlineDot.css';

interface OnlineDotProps {
  online: boolean;
  /** Size in px, default 6 */
  size?: number;
  className?: string;
}

export function OnlineDot({ online, size = 6, className }: OnlineDotProps) {
  return (
    <span
      className={`${s.base} ${s.stateStyles[online ? 'online' : 'offline']}${
        className ? ` ${className}` : ''
      }`}
      style={{ width: size, height: size }}
      aria-label={online ? '온라인' : '오프라인'}
      role="status"
    />
  );
}
